import React from 'react'

const Div = (props) => {
    return (
        <div style={props?.style || {}}>
            {props.children}
        </div>
    )
}

export default Div